module.exports = __webpack_public_path__ + "img/info-gratis-jawa-bali.1f41035e.png";